import { Flex } from "@revoo/design-system/ui/Flex/Flex";
import { Icon } from "@revoo/design-system/ui/Icon/Icon";
import { Spinner } from "@revoo/design-system/ui/Spinner/Spinner";
import React from "react";
import Logo from "@/assets/icons/Logo";

const AppLoader = () => {
  return (
    <Flex alignItems="center" justifyContent="center" w="100vw" h="100vh">
      <Spinner size="sm" mr={2} />
      <Icon icon={Logo} size="5xl" h={16} w={28} />
    </Flex>
  );
};

export default AppLoader;
